import { buildReducer, PersonType } from '../../../shared';
import { CreateEditMode } from '../../state/view/createEditorsState';
import {
    editOrCreatePrivateDLCancelClickedAction,
    privateDLCreatedAction,
    privateDLEditedAction,
} from '../../../privatedlcreateedit';
import {
    personaEditClickedAction,
    personAddClickedAction,
    newPersonaClickedAction,
    contactEditorNewContactSaveClickedAction,
    contactEditorExistingContactSaveClickedAction,
    contactEditorCancelClickedAction,
} from '../../../hub';
import {
    createGroupClickedAction,
    dismissCreateGroupDialogAction,
    editGroupClickedAction,
    dismissEditGroupDialogAction,
    addGroupMembersClickedAction,
    dismissAddGroupMembersDialogAction,
    inviteToGroupClickedAction,
    dismissInviteToGroupDialogAction,
} from '../../../editors/actions';
import { lpcAddGroupMembersClickedAction, lpcEditGroupClickedAction } from '../../actions';

export default buildReducer<CreateEditMode>()
    .handle(personaEditClickedAction, () => CreateEditMode.EditPersona)
    .handle(personAddClickedAction, () => CreateEditMode.AddPerson)
    .handle(newPersonaClickedAction, (_state, action) =>
        action.payload.hubPersonaType === PersonType.Person
            ? CreateEditMode.CreatePerson
            : CreateEditMode.CreatePrivateDL
    )
    .handle(editOrCreatePrivateDLCancelClickedAction, () => null)
    .handle(contactEditorNewContactSaveClickedAction, () => null)
    .handle(contactEditorExistingContactSaveClickedAction, () => null)
    .handle(privateDLCreatedAction, () => null)
    .handle(privateDLEditedAction, () => null)
    .handle(contactEditorCancelClickedAction, () => null)
    .handle(createGroupClickedAction, () => {
        return CreateEditMode.CreateGroup;
    })
    .handle(editGroupClickedAction, () => {
        return CreateEditMode.EditGroup;
    })
    .handle(lpcEditGroupClickedAction, () => {
        return CreateEditMode.EditGroup;
    })
    .handle(addGroupMembersClickedAction, (_state, action) => {
        if (action.payload.groupKind == 3) {
            return null;
        }
        return CreateEditMode.AddMemberToGroup;
    })
    .handle(lpcAddGroupMembersClickedAction, () => {
        return CreateEditMode.AddMemberToGroup;
    })
    .handle(inviteToGroupClickedAction, () => {
        return CreateEditMode.InviteToGroup;
    })
    .handle(dismissCreateGroupDialogAction, () => null)
    .handle(dismissEditGroupDialogAction, () => null)
    .handle(dismissAddGroupMembersDialogAction, () => null)
    .handle(dismissInviteToGroupDialogAction, () => null)
    .done(null);
export type { Action } from '../../../shared';
